import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AppLinkContent() {
  const { user, loading } = useAuth();

  if (loading) return null;

  return (
     <Link to="/account" style={{ color: '#228B22' }} className="hover:underline">👤 Account</Link>
  );
}
